import { css } from "@linaria/core";
import {
  units,
  colors,
  breakpoints,
  typographies,
  scrambledMixin,
} from "@pm2/compat";

export const wrapper = css`
  box-sizing: border-box;
  width: 100%;
  min-height: ${units.px(150)};

  background-color: ${colors.gray.alpha03()};
  border-radius: ${units.px(4)};

  display: flex;
  gap: ${units.px(20)};

  @media ${breakpoints.mobile.andDown().toQuery()} {
    min-height: ${units.px(100)};
    gap: ${units.px(17)};
  }
`;

export const text = css`
  display: flex;
  flex-direction: column;
  gap: ${units.px(5)};
`;

export const content = css`
  padding-block: ${units.px(15)} ${units.px(7)};
  padding-right: ${units.px(30)};

  box-sizing: border-box;
  height: 100%;

  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-self: center;
  justify-content: center;

  @media ${breakpoints.mobile.andDown().toQuery()} {
    padding-right: ${units.px(17)};
  }

  &:has(.${text}:empty) {
    padding-block: 0;
  }
`;

export const title = css`
  font-family: ${typographies.heading4()};

  &:last-child {
    margin-bottom: ${units.px(5)};
  }

  &[data-scrambled="true"] {
    ${scrambledMixin()};
  }
`;
